import { Outlet } from "react-router-dom";
import './_default-layout.scss';
import StickyHeader from "../../components/sticky-header";
import LayoutContextContainer from '../../components/layout-context-container';
import PatientHeader from "../../components-patient/header";
import PatientInterstitial from "../../components/interstitial";
import PatientJumpToSection from "@/components-patient/jump-to-section";
import AutoScrollActive from "@/components/auto-scroll-active";
// import PatientTooltip from "../../components/tooltip";

function DefaultLayout() {

  return (
    <div className="default-layout">
      <LayoutContextContainer>
        <AutoScrollActive />
        <StickyHeader>
          <PatientJumpToSection links={null} isSticky />
        </StickyHeader>
        <PatientHeader />
        <Outlet />
        {/* <PatientTooltip /> */}
        <PatientInterstitial showCloseButton={true} />
      </LayoutContextContainer>
    </div>
  )
}

export default DefaultLayout;